// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__fl4is","status":"style_status__TRQ4g","report":"style_report__OQfxs","actions":"style_actions__8T5zc","actions_btn":"style_actions_btn__fwfEp"};